// English strings (source language): training.

const en = {
  title: 'Training',
  intro: (ftp: number) => `Structured ERG workouts based on your FTP (${ftp} W). During the workout, you ride the course selected in Play.`,
  tabs: { workouts: 'Workouts', plans: 'Plans', create: 'Create' },
  all: 'All',
  mine: 'My workouts',
  custom: 'Custom',
  testFtp: 'FTP test',
  ftpTest: {
    title: 'A Ramp test would set your FTP',
    reasons: {
      unknown: 'Your workouts set the power for you, so they cannot tell how strong you are. About 20 minutes, ending all out.',
      stale: 'Your FTP rests on efforts from more than six weeks ago. A test tells where you are now.',
      return: 'Welcome back. After a break, a test sets workouts at the right level again.',
      struggling: 'Your last workouts were hard to hold: your FTP may be too high. A test sets it right.',
    },
    start: 'Ramp test',
  },
  emptyList: 'No workouts here.',
  free: 'Free',
  duration: 'Duration',
  tssEst: 'Estimated TSS',
  intensity: 'Intensity (IF)',
  blocks: 'Blocks',
  targetsHelp: (ftp: number) => `Targets computed for your FTP of ${ftp} W. In ERG mode, the trainer sets the power: keep a steady cadence.`,
  shortcuts: 'Shortcuts during the workout:',
  kIntensity: 'intensity',
  kNext: 'next block',
  delete: 'Delete',
  exportZwo: 'Export .zwo',
  startWorkout: 'Start workout',
  withOthers: 'Ride it with others',
  deleteConfirm: (name: string) => `Delete “${name}”?`,
  current: (name: string) => `In progress: ${name}`,
  abandonPlan: 'Abandon plan',
  week: (n: number) => `Week ${n}`,
  planDone: '🎓 Plan completed, well done!',
  tssPerWeek: (n: number) => `≈ ${n} TSS / week`,
  inProgress: 'In progress',
  startPlan: 'Start this plan',
  planStarted: 'Plan started 💪',
  abandonConfirm: 'Abandon the current plan?',
  abandon: 'Abandon',
  create: 'Create a workout',
  name: 'Name',
  defaultName: 'My workout',
  category: 'Category',
  description: 'Description',
  descPlaceholder: 'Workout goal',
  add: { steady: '+ Steady', ramp: '+ Ramp', intervals: '+ Intervals', free: '+ Free ride' },
  importTitle: 'Import a .zwo file',
  importHelp: 'Zwift workout files (.zwo) work here: steady blocks, ramps, intervals and free ride.',
  segLabels: { steady: 'Steady (min, %)', ramp: 'Ramp (min, %→%)', intervals: 'Intervals (×, s, %, s)', free: 'Free ride (min)' },
  inputs: { min: 'min', pFtp: '% FTP', pStart: '% start', pEnd: '% end', reps: 'repetitions', onDur: 'effort (s)', onP: '% effort', offDur: 'recovery (s)' },
  needBlock: 'Add at least one block',
  saved: 'Workout saved',
  imported: (name: string) => `“${name}” imported`,
  rideIn: 'Ride…',
  rideOnTrack: 'on the track chosen in Play',
  rideInGame: (name: string) => `in the game “${name}”`,
  remix: 'Rework in the workshop',
  createWithWorkshop: 'Create with the workshop',
  openStore: 'Store',
  createPlan: 'Create my plan',
  createPlanHelp: 'Describe your goal, availability and volume: the workshop builds the weeks.',
  yours: 'yours',
  community: 'community',
  days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  swapped: 'Workout swapped by the plan adaptation',
  optional: 'Optional workout',
  optionalTag: '(optional)',
  adaptive: 'Adaptive plan',
  adaptIntensity: (pct: number) => `workout intensity <b>${pct}%</b>`,
};
export default en;
